<template>
<div class="debug-component">
  <div class="text-primary">
    <ul class="memo-text">
      <li>※ここはsuper admin権限でログインした場合のみ表示される開発者用領域です。</li>
      <li>※検索系ボタンはサーバに検索リクエストが飛び一応多少のシステム負荷がかかるので、あまり連打はしないでください。</li>
    </ul>
  </div>

  <TopDebugComponentTool1
    :ref-extreme-map="refExtremeMap"
    :cars="cars" />
</div>
</template>

<script setup lang="ts">
import TopDebugComponentTool1 from './tool1.vue';
import type { DebugToolProps } from 'src/models/top';

defineProps<DebugToolProps>();
</script>

<style lang="scss" scoped>
.debug-component {
  max-width: 900px;
  padding: 12px;
  background-color: #eeeeee;
  border: 2px dotted #158cba;
  border-radius: 6px;

}
.memo-text {
  list-style: none;
  padding: 0;
}
</style>
